export const welcome = 'Welcome.';
export const title = 'Thank you for your interest in BeeHero.';
export const subtitle =
    'Please fill in your contact information and select your identity so we can best respond to your inquiry.';
export const sendDetails = 'Send Contact Info';
export const sendAndGoToDemo = 'Send Contact Info & Proceed To Demo';
export const rolesTitle = 'I am a...';
export const thankYou = 'Thank you!';
export const toTheDemo = 'To The Demo';
export const willContactYouSoon = 'We Will Contact You Soon.';
export const beeheroIo = 'Beehero.io';
export const radioButtons = ['grower', 'beekeeper', 'media', 'other'];
export const goToDemo = 'goToDemo';
export const someThingWentWrong = 'Oops... something went wrong';
export const nameLabel = 'Name*';
export const namePlaceholder = 'Name';
export const emailLabel = 'Email*';
export const emailPlaceholder = 'Email';
export const organizationLabel = 'Organization Name (Optional)';
export const organizationPlaceholder = 'Organization Name';
export const phoneLabel = 'Phone Number (Optional)';
export const phonePlaceholder = 'Phone Number';
export const beeheroTitle = 'BeeHero';
